import { TComponentWidth } from '@/types/global';
import { medias } from '@/utils/sizes';
import styled, { css } from 'styled-components';

export const TwoColContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['width', 'pageType', 'borderTop', 'paddingTop', 'isInverted', 'paddingTopMobile'].includes(
      prop
    ),
})<{
  width: TComponentWidth;
  pageType: 'project' | 'page';
  borderTop: boolean;
  paddingTop: 'inner' | 'none' | 'inner-xl';
  paddingTopMobile?: boolean;
  isInverted?: boolean;
}>`
  display: grid;

  ${({ width, pageType, borderTop, paddingTop, isInverted, paddingTopMobile }) => css`
    grid-template-columns: ${
      pageType === 'page' || (pageType === 'project' && width === 'main')
        ? !isInverted
          ? '25% 75%'
          : '75% 25%'
        : !isInverted
          ? '19.8% 80.2%'
          : '80.2% 19.8%'
    };
    border-top: ${borderTop ? '1px solid var(--c-border)' : 'none'};
    padding-top: ${
      borderTop ? `var(--spacing-component-${paddingTop})` : 'none'
    };

    ${medias.only.desktopSm} {
      grid-template-columns: ${!isInverted ? '22.3% 77.7%' : '77.7% 22.3%'};
    }

    ${medias.max.tablet} {
      display: flex;
      flex-direction: column;
    }

    ${medias.max.mobile} {
      .side-text {
        color: var(--c-font-primary);
      }
      ${!paddingTopMobile && 'padding-top: 0 !important;'}
  `}

  &.container-filters-sections {
    grid-template-rows: min-content;
  }

  ${medias.max.mobile} {
    padding-top: 32px;
  };

  ${medias.max.tablet} {
    &.has-text-content {
      padding-top: 32px;

      .side-text {
        margin-bottom: 0;
      }
    }

    &.has-text-content.no-border-top {
      padding-top: 0;  
    }
  }
`;

export const SideText = styled.div`
  ${medias.max.tablet} {
    .typography {
      font-size: var(--fs-lg);
      margin-bottom: var(--spacing-component-inner);
    }
  }

  ${medias.max.mobile} {
    .typography {
      margin-bottom: 32px;
    }
  }
`;
